import { FormProvider, useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { TextArea } from 'src/app/@core/forms/controls/textArea';
import { DialogHeaderContent } from 'src/app/@core/forms/controls/dialogHeaderContent';
import {
  DialogBase,
  DialogModelBase,
} from 'src/app/@core/forms/dialog/@dialogBaseV2';
/**
 *
 */
export class NotesOrderEditDeleteDialogModel extends DialogModelBase {
  /**
   *
   */
  constructor() {
    super();
    this.productionID = '';
    this.frmLocal = useForm({ mode: 'onChange', defaultValues: {} });
  }
}

export class Notes1DeleteDialogController extends DialogBase {
  /**
   *
   * @param {*} model
   * @param {*} setModel
   */
  constructor(model, setModel) {
    super(model, setModel);
  }

  /**
   *
   * @param {*} frmVals
   */
  submit = async (frmVals) => {
    try {
      this.spinner().show();
      const dto = frmVals;
      await this.api().productionNoteApi.delete(dto.notesID);
      this.hide({ status: 200 });
    } catch (err) {
      console.log(err);
    } finally {
      this.spinner().hide();
    }
  };

  /**
   *
   * @param {*} item
   * @returns
   */
  show = (item) => {
    this.model.frmLocal.reset(item);
    return super.show();
  };
}

/**
 *
 * @param {*} props
 * @returns
 */
export const Notes1DeleteDialog = (props) => {
  const { controller } = props;
  const { frmLocal } = controller.model;
  const { control, getValues, handleSubmit } = frmLocal;

  /**
   *
   */
  const onClose = () => {};

  /**
   *
   */
  const onSubmit = async () => {
    controller.submit(getValues());
  };

  return (
    <Dialog
      fullScreen
      style={{ margin: 'auto', maxWidth: 500, maxHeight: 450 }}
      open={controller.visible()}
      onClose={controller.close}
      scroll='paper'
      aria-labelledby='scroll-dialog-title'
      aria-describedby='scroll-dialog-description'
    >
      <DialogTitle id='scroll-dialog-title'>
        <DialogHeaderContent title='Delete Note' onClose={controller.close} />
      </DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)} className='dialog-form_inner'>
        <DialogContent dividers={true}>
          <FormProvider {...frmLocal}>
            <div>
              <div className='flex -mx-4'>
                <TextArea
                  id='noteDescription'
                  label='Notes'
                  control={control}
                  rows={13}
                  disabled={true}
                />
              </div>
            </div>
          </FormProvider>
        </DialogContent>
        <DialogActions>
          <Button
            variant='contained'
            color='primary'
            onClick={controller.close}
          >
            Cancel
          </Button>
          <Button variant='contained' color='error' type='submit'>
            Delete
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
